import React, { useEffect, useState } from "react";

import { getBreadcrumbs } from "../../../shared/util/common/getBreadcrumbs";
import withAppLayout from "../../../shared/components/withAppLayout";
import DOMPurify from "dompurify";
import { TITLE } from "../../../shared/util/constants/title";
import SideNavigation from "../../components/common/SideNavigation";
import AuditsTable from "../../components/Audits/AuditsTable";

const AuditsPage = () => {
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    document.title = DOMPurify.sanitize(`${TITLE} - Audits`);
  });

  return withAppLayout({
    component: (
      <React.Fragment>
        <AuditsTable setNotifications={setNotifications} />
      </React.Fragment>
    ),
    breadcrumbs: getBreadcrumbs({ text: "Audits" }),
    navigationHide: false,
    navigation: <SideNavigation />,
    toolsHide: true,
    notificationsItems: notifications,
  })();
};

export default AuditsPage;
